import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {EmpVariableAttributes, PayPeriodAttributes} from '../../../../models/models.interfaces';
import {Contract} from '../../../../shared/employees/employees.model';
import {Data} from '../../../../shared/api';

@Component({
  selector: 'gp-payroll-prepare-variable-elements-multiple-payperiod',
  templateUrl: './variable-elements-multiple-payperiod.component.html',
  styleUrls: ['./variable-elements-multiple-payperiod.component.scss']
})
export class VariableElementsMultiplePayperiodComponent {
  @Output()
  public onEditElement: EventEmitter<Data<EmpVariableAttributes>> = new EventEmitter();

  @Output()
  public onCreateElement: EventEmitter<Data<EmpVariableAttributes>> = new EventEmitter();

  @Input()
  public editedPayPeriod: Data<PayPeriodAttributes>;

  @Input()
  public previousPayPeriod: Data<PayPeriodAttributes>;

  @Input()
  public nextPayPeriod: Data<PayPeriodAttributes>;

  @Input()
  public variableElements: { [name: string]: Data<EmpVariableAttributes>[] };

  @Input()
  public readOnly = false;

  @Input()
  public contract: Contract;

  @Input()
  public loading = false;

  @Input()
  public canNavigateBack: boolean;

  @Input()
  public canNavigateForward: boolean;

  @Input()
  public isVariablesV2Enabled: boolean;

  @Output()
  public variableElementDeletedNew: EventEmitter<{
    item: Data<EmpVariableAttributes>,
    isNested: boolean,
    type: string
  }> = new EventEmitter();

  @Output()
  public variableElementDeleted: EventEmitter<{
    item: Data<EmpVariableAttributes>,
    isNested: boolean,
    type: string
  }> = new EventEmitter();

  @Output()
  public isDirty: EventEmitter<Data<EmpVariableAttributes>> = new EventEmitter();

  @Output()
  public onPrevious: EventEmitter<void> = new EventEmitter();

  @Output()
  public onNext: EventEmitter<void> = new EventEmitter();

  public expanded: { [key: string]: boolean } = {};

  public objectKeys = Object.keys;
  public json = JSON;

  public localLoading = false;

  constructor(private ref: ChangeDetectorRef
  ) {
  }

  public navigatePrevious(): void {
    this.onPrevious.emit();
  }

  public navigateNext(): void {
    this.onNext.emit();
  }

  public createVariable(): void {
    this.onCreateElement.emit();
  }

  public editVariable(variable: Data<EmpVariableAttributes>): void {
    this.onEditElement.emit(variable);
  }

  public variableDeleted(element: {
    item: Data<EmpVariableAttributes>,
    isNested: boolean,
    type: string
  }): void {
    this.variableElementDeleted.emit(element);
  }

  public variableDeletedNew(element: {
    item: Data<EmpVariableAttributes>,
    isNested: boolean,
    type: string
  }): void {
    this.variableElementDeletedNew.emit(element);
  }

  public markAsDirty(element: Data<EmpVariableAttributes>): void {
    this.isDirty.emit(element);
  }
}
